module.exports = __webpack_public_path__ + "img/icon-differentials_03.d4e4491d.svg";